import React from 'react';
import './BottomBanner.scss';
import GlobalButton from '@/components/Button/button';
import { Launch } from '@carbon/icons-react';

interface CtaItem {
  label: string;
  href: string;
}

interface BottomBannerProps {
  title: string;
  subHeader?: string;
  /** Single description label shown above the main button (used when no ctas provided) */
  description?: string;
  /** Single bottom button (used when no ctas provided) */
  buttonText?: string;
  /** Single bottom button link (used when no ctas provided) */
  buttonLink?: string;
  /** Split CTA items — each label is itself a clickable link */
  ctas?: CtaItem[];
  /** Optional standalone button shown below split CTAs */
  learnMoreText?: string;
  learnMoreLink?: string;
  backgroundColor?: string;
}

const BottomBanner: React.FC<BottomBannerProps> = ({
  title,
  subHeader,
  description,
  buttonText,
  buttonLink,
  ctas,
  learnMoreText,
  learnMoreLink,
  backgroundColor = '#f4f4f4',
}) => {
  return (
    <div className="bottom-banner" style={{ backgroundColor }}>
      <div className="bottom-banner-content">
        <div className="bottom-banner-left">
          <h4 className="bottom-banner-title">{title}</h4>
          {subHeader && <p className="bottom-banner-subtitle">{subHeader}</p>}
        </div>
        <div className="bottom-banner-right">
          {ctas && ctas.length > 0 ? (
            <>
              <div className="bottom-banner-ctas">
                {ctas.map((cta, i) => (
                  <a
                    key={i}
                    href={cta.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bottom-banner-cta-link"
                  >
                    <span>{cta.label}</span>
                    <Launch size={18} aria-label="Opens in new tab" />
                  </a>
                ))}
              </div>
              {learnMoreText && learnMoreLink && (
                <GlobalButton
                  color="primary"
                  icon="ArrowRight"
                  text={learnMoreText}
                  href={learnMoreLink}
                  target="_blank"
                />
              )}
            </>
          ) : (
            <>
              {description && (
                <p className="bottom-banner-description">{description}</p>
              )}
              {buttonText && buttonLink && (
                <GlobalButton
                  color="primary"
                  icon="ArrowRight"
                  text={buttonText}
                  href={buttonLink}
                  target="_blank"
                />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default BottomBanner;